module.exports = __webpack_public_path__ + "media/flags/th-9e7c7a3f.svg";